export default __webpack_public_path__ + "static/section_4_details_1-05e775d648495d95d74aa5dab56edfd2.png";